export default __webpack_public_path__ + "static/media/Qnergy_HOR_NoTag_RGB.cb56eab6.svg";